@file:OptIn(InternalResourceApi::class)

package showcaseapp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.RegionQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/showcaseapp.composeapp.generated.resources/"

@delegate:ResourceContentHash(791_915_845)
internal val Res.string.unsplash_orientation_all: StringResource by lazy {
      StringResource("string:unsplash_orientation_all", "unsplash_orientation_all", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25059, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28304, 56),
      ))
    }

@delegate:ResourceContentHash(1_425_929_981)
internal val Res.string.unsplash_orientation_landscape: StringResource by lazy {
      StringResource("string:unsplash_orientation_landscape", "unsplash_orientation_landscape", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25108, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28361, 50),
      ))
    }

@delegate:ResourceContentHash(-19_008_159)
internal val Res.string.unsplash_orientation_portrait: StringResource by lazy {
      StringResource("string:unsplash_orientation_portrait", "unsplash_orientation_portrait", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25155, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28412, 49),
      ))
    }

@delegate:ResourceContentHash(258_298_807)
internal val Res.string.unsplash_orientation_squarish: StringResource by lazy {
      StringResource("string:unsplash_orientation_squarish", "unsplash_orientation_squarish", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25201, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28462, 45),
      ))
    }

@delegate:ResourceContentHash(915_237_993)
internal val Res.string.unsplash_topics_photos: StringResource by lazy {
      StringResource("string:unsplash_topics_photos", "unsplash_topics_photos", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28561, 50),
      ))
    }

@delegate:ResourceContentHash(1_914_417_222)
internal val Res.string.unsplash_users_collections: StringResource by lazy {
      StringResource("string:unsplash_users_collections", "unsplash_users_collections", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28612, 58),
      ))
    }

@delegate:ResourceContentHash(-312_132_791)
internal val Res.string.unsplash_users_likes: StringResource by lazy {
      StringResource("string:unsplash_users_likes", "unsplash_users_likes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28671, 56),
      ))
    }

@delegate:ResourceContentHash(2_013_247_663)
internal val Res.string.unsplash_users_photos: StringResource by lazy {
      StringResource("string:unsplash_users_photos", "unsplash_users_photos", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28728, 49),
      ))
    }

@delegate:ResourceContentHash(501_656_653)
internal val Res.string.unsupport_type: StringResource by lazy {
      StringResource("string:unsupport_type", "unsupport_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28778, 46),
      ))
    }

@delegate:ResourceContentHash(736_074_450)
internal val Res.string.unsupported_type: StringResource by lazy {
      StringResource("string:unsupported_type", "unsupported_type", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25292, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28825, 48),
      ))
    }

@delegate:ResourceContentHash(-2_029_051_776)
internal val Res.string.up_to_date: StringResource by lazy {
      StringResource("string:up_to_date", "up_to_date", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25345, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28874, 34),
      ))
    }

@delegate:ResourceContentHash(845_576_189)
internal val Res.string.update: StringResource by lazy {
      StringResource("string:update", "update", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25415, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28944, 22),
      ))
    }

@delegate:ResourceContentHash(834_081_288)
internal val Res.string.update_version: StringResource by lazy {
      StringResource("string:update_version", "update_version", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25384, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28909, 34),
      ))
    }

@delegate:ResourceContentHash(-1_579_478_698)
internal val Res.string.url_is_invalid: StringResource by lazy {
      StringResource("string:url_is_invalid", "url_is_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25438, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28967, 42),
      ))
    }

@delegate:ResourceContentHash(-1_807_667_500)
internal val Res.string.user: StringResource by lazy {
      StringResource("string:user", "user", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25477, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29039, 20),
      ))
    }

@delegate:ResourceContentHash(321_900_492)
internal val Res.string.userName: StringResource by lazy {
      StringResource("string:userName", "userName", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29010, 28),
      ))
    }

@delegate:ResourceContentHash(2_051_980_985)
internal val Res.string.very_fast: StringResource by lazy {
      StringResource("string:very_fast", "very_fast", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25502, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29060, 29),
      ))
    }

@delegate:ResourceContentHash(2_051_688_460)
internal val Res.string.very_large: StringResource by lazy {
      StringResource("string:very_large", "very_large", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25528, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29090, 34),
      ))
    }

@delegate:ResourceContentHash(1_357_255_094)
internal val Res.string.very_slow: StringResource by lazy {
      StringResource("string:very_slow", "very_slow", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25555, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29125, 29),
      ))
    }

@delegate:ResourceContentHash(-207_333_305)
internal val Res.string.very_small: StringResource by lazy {
      StringResource("string:very_small", "very_small", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25581, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29155, 34),
      ))
    }

@delegate:ResourceContentHash(65_622_358)
internal val Res.string.waterfall_column_count: StringResource by lazy {
      StringResource("string:waterfall_column_count", "waterfall_column_count", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25608, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29190, 46),
      ))
    }

@delegate:ResourceContentHash(908_718_286)
internal val Res.string.waterfall_row_count: StringResource by lazy {
      StringResource("string:waterfall_row_count", "waterfall_row_count", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25647, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29237, 39),
      ))
    }

@delegate:ResourceContentHash(836_544_561)
internal val Res.string.waterfall_scroll_speed: StringResource by lazy {
      StringResource("string:waterfall_scroll_speed", "waterfall_scroll_speed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25683, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29277, 46),
      ))
    }

@delegate:ResourceContentHash(-1_629_291_489)
internal val Res.string.waterfall_spacing: StringResource by lazy {
      StringResource("string:waterfall_spacing", "waterfall_spacing", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25730, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29324, 37),
      ))
    }

@delegate:ResourceContentHash(154_626_282)
internal val Res.string.weather_desc_clear_day: StringResource by lazy {
      StringResource("string:weather_desc_clear_day", "weather_desc_clear_day", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25764, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29362, 38),
      ))
    }

@delegate:ResourceContentHash(154_626_282)
internal val Res.string.weather_desc_clear_night: StringResource by lazy {
      StringResource("string:weather_desc_clear_night", "weather_desc_clear_night", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25799, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29401, 40),
      ))
    }

@delegate:ResourceContentHash(-463_385_309)
internal val Res.string.weather_desc_cloudy: StringResource by lazy {
      StringResource("string:weather_desc_cloudy", "weather_desc_cloudy", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25836, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29442, 35),
      ))
    }

@delegate:ResourceContentHash(688_726_311)
internal val Res.string.weather_desc_drizzle: StringResource by lazy {
      StringResource("string:weather_desc_drizzle", "weather_desc_drizzle", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25872, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29478, 40),
      ))
    }

@delegate:ResourceContentHash(-764_051_820)
internal val Res.string.weather_desc_mist: StringResource by lazy {
      StringResource("string:weather_desc_mist", "weather_desc_mist", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25909, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29519, 33),
      ))
    }

@delegate:ResourceContentHash(-557_132_922)
internal val Res.string.weather_desc_overcast: StringResource by lazy {
      StringResource("string:weather_desc_overcast", "weather_desc_overcast", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25939, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29553, 41),
      ))
    }

@delegate:ResourceContentHash(-2_068_160_887)
internal val Res.string.weather_desc_rain: StringResource by lazy {
      StringResource("string:weather_desc_rain", "weather_desc_rain", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25973, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29595, 33),
      ))
    }

@delegate:ResourceContentHash(922_617_361)
internal val Res.string.weather_desc_snow: StringResource by lazy {
      StringResource("string:weather_desc_snow", "weather_desc_snow", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 26003, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29629, 33),
      ))
    }

@delegate:ResourceContentHash(-314_991_463)
internal val Res.string.weather_desc_thunderstorm: StringResource by lazy {
      StringResource("string:weather_desc_thunderstorm", "weather_desc_thunderstorm", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 26033, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29663, 41),
      ))
    }

@delegate:ResourceContentHash(75_053_696)
internal val Res.string.weather_desc_unknown: StringResource by lazy {
      StringResource("string:weather_desc_unknown", "weather_desc_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 26075, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29705, 32),
      ))
    }

@delegate:ResourceContentHash(1_608_632_487)
internal val Res.string.weather_error_fetch_failed: StringResource by lazy {
      StringResource("string:weather_error_fetch_failed", "weather_error_fetch_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 26108, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29738, 70),
      ))
    }

@delegate:ResourceContentHash(-1_642_177_893)
internal val Res.string.weather_error_location_unavailable: StringResource by lazy {
      StringResource("string:weather_error_location_unavailable", "weather_error_location_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 26175, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29809, 74),
      ))
    }

@delegate:ResourceContentHash(741_914_809)
internal val Res.string.web_source_browser_access_error: StringResource by lazy {
      StringResource("string:web_source_browser_access_error", "web_source_browser_access_error", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 26250, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29884, 207),
      ))
    }

@delegate:ResourceContentHash(-1_805_586_259)
internal val Res.string.webdav_browser_access_error: StringResource by lazy {
      StringResource("string:webdav_browser_access_error", "webdav_browser_access_error", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 26442, 279),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30092, 303),
      ))
    }

@delegate:ResourceContentHash(-1_426_690_829)
internal val Res.string.weibo_original: StringResource by lazy {
      StringResource("string:weibo_original", "weibo_original", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 26722, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30396, 42),
      ))
    }

@delegate:ResourceContentHash(2_051_391_090)
internal val Res.string.weibo_retweet: StringResource by lazy {
      StringResource("string:weibo_retweet", "weibo_retweet", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 26761, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30439, 33),
      ))
    }

@delegate:ResourceContentHash(-375_660_953)
internal val Res.string.weibo_type_must_selected: StringResource by lazy {
      StringResource("string:weibo_type_must_selected", "weibo_type_must_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 26799, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30473, 92),
      ))
    }

@delegate:ResourceContentHash(-1_189_482_057)
internal val Res.string.weibo_uid_tips_1: StringResource by lazy {
      StringResource("string:weibo_uid_tips_1", "weibo_uid_tips_1", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 26868, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30566, 112),
      ))
    }

@delegate:ResourceContentHash(108_091_698)
internal val Res.string.weibo_uid_tips_2: StringResource by lazy {
      StringResource("string:weibo_uid_tips_2", "weibo_uid_tips_2", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 26941, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30679, 132),
      ))
    }

@delegate:ResourceContentHash(413_990_046)
internal val Res.string.weibo_uid_tips_3: StringResource by lazy {
      StringResource("string:weibo_uid_tips_3", "weibo_uid_tips_3", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 27026, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30812, 112),
      ))
    }

@delegate:ResourceContentHash(505_076_000)
internal val Res.string.weibo_uid_tips_4: StringResource by lazy {
      StringResource("string:weibo_uid_tips_4", "weibo_uid_tips_4", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 27099, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30925, 160),
      ))
    }

@delegate:ResourceContentHash(-1_336_876_763)
internal val Res.string.weibo_uid_tips_title: StringResource by lazy {
      StringResource("string:weibo_uid_tips_title", "weibo_uid_tips_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 27220, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31086, 68),
      ))
    }

@delegate:ResourceContentHash(747_621_866)
internal val Res.string.welcome: StringResource by lazy {
      StringResource("string:welcome", "welcome", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 27281, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31155, 27),
      ))
    }

@delegate:ResourceContentHash(-356_288_549)
internal val Res.string.your_api_key: StringResource by lazy {
      StringResource("string:your_api_key", "your_api_key", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 27313, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31183, 36),
      ))
    }

@delegate:ResourceContentHash(-1_345_587_912)
internal val Res.string.zoom_effect: StringResource by lazy {
      StringResource("string:zoom_effect", "zoom_effect", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 27346, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31220, 35),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString6Resources(map: MutableMap<String, StringResource>) {
  map.put("unsplash_orientation_all", Res.string.unsplash_orientation_all)
  map.put("unsplash_orientation_landscape", Res.string.unsplash_orientation_landscape)
  map.put("unsplash_orientation_portrait", Res.string.unsplash_orientation_portrait)
  map.put("unsplash_orientation_squarish", Res.string.unsplash_orientation_squarish)
  map.put("unsplash_topics_photos", Res.string.unsplash_topics_photos)
  map.put("unsplash_users_collections", Res.string.unsplash_users_collections)
  map.put("unsplash_users_likes", Res.string.unsplash_users_likes)
  map.put("unsplash_users_photos", Res.string.unsplash_users_photos)
  map.put("unsupport_type", Res.string.unsupport_type)
  map.put("unsupported_type", Res.string.unsupported_type)
  map.put("up_to_date", Res.string.up_to_date)
  map.put("update", Res.string.update)
  map.put("update_version", Res.string.update_version)
  map.put("url_is_invalid", Res.string.url_is_invalid)
  map.put("user", Res.string.user)
  map.put("userName", Res.string.userName)
  map.put("very_fast", Res.string.very_fast)
  map.put("very_large", Res.string.very_large)
  map.put("very_slow", Res.string.very_slow)
  map.put("very_small", Res.string.very_small)
  map.put("waterfall_column_count", Res.string.waterfall_column_count)
  map.put("waterfall_row_count", Res.string.waterfall_row_count)
  map.put("waterfall_scroll_speed", Res.string.waterfall_scroll_speed)
  map.put("waterfall_spacing", Res.string.waterfall_spacing)
  map.put("weather_desc_clear_day", Res.string.weather_desc_clear_day)
  map.put("weather_desc_clear_night", Res.string.weather_desc_clear_night)
  map.put("weather_desc_cloudy", Res.string.weather_desc_cloudy)
  map.put("weather_desc_drizzle", Res.string.weather_desc_drizzle)
  map.put("weather_desc_mist", Res.string.weather_desc_mist)
  map.put("weather_desc_overcast", Res.string.weather_desc_overcast)
  map.put("weather_desc_rain", Res.string.weather_desc_rain)
  map.put("weather_desc_snow", Res.string.weather_desc_snow)
  map.put("weather_desc_thunderstorm", Res.string.weather_desc_thunderstorm)
  map.put("weather_desc_unknown", Res.string.weather_desc_unknown)
  map.put("weather_error_fetch_failed", Res.string.weather_error_fetch_failed)
  map.put("weather_error_location_unavailable", Res.string.weather_error_location_unavailable)
  map.put("web_source_browser_access_error", Res.string.web_source_browser_access_error)
  map.put("webdav_browser_access_error", Res.string.webdav_browser_access_error)
  map.put("weibo_original", Res.string.weibo_original)
  map.put("weibo_retweet", Res.string.weibo_retweet)
  map.put("weibo_type_must_selected", Res.string.weibo_type_must_selected)
  map.put("weibo_uid_tips_1", Res.string.weibo_uid_tips_1)
  map.put("weibo_uid_tips_2", Res.string.weibo_uid_tips_2)
  map.put("weibo_uid_tips_3", Res.string.weibo_uid_tips_3)
  map.put("weibo_uid_tips_4", Res.string.weibo_uid_tips_4)
  map.put("weibo_uid_tips_title", Res.string.weibo_uid_tips_title)
  map.put("welcome", Res.string.welcome)
  map.put("your_api_key", Res.string.your_api_key)
  map.put("zoom_effect", Res.string.zoom_effect)
}
